export const ERROR_CODES = {
  MISSING_EMAIL_VERIFICATION: 'missingEmailVerification'
};
